<mat-toolbar>
  <a routerLink="/networks">Hálózatok</a>
  @if (title) {
    <span >&nbsp;/ {{title}}</span>
  }
  <span class="toolbar-spacer"></span>
  @if (company && company.id) {
    <a type="button" mat-raised-button color="primary" routerLink="/device/new" target="_blank">Új eszköz regisztrálása</a>
  }
  @if (company && company.id) {
    <button type="button" mat-raised-button color="primary" (click)="onNewMeterBtnClick()" class="ms-2">Raktáron levő eszköz telepítése</button>
  }
</mat-toolbar>

@if (!rootNode) {
  <div class="my-2">
    <app-select-search label="Cég" [list]="companies" [model]="options.company" (modelChanged)="fetchCompany($event);" [isDisabled]="!companies.length"></app-select-search>
  </div>
}

@if (company && company.id && !rootNode) {
  <div>
    <p>Eszköz telepítve.</p>
  </div>
}

<div class="row">
  <div class="col-md-8">
    <div class="tree-container pt-4">
      @if (treeLoaded) {
        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
          <mat-nested-tree-node *matTreeNodeDef="let node">
            <li>
              <div class="mat-tree-node">
                <mat-icon>{{node.icon}}</mat-icon>
                <span>{{node.target ? node.target : node.name}}</span>
                @if (node.id) {
                  <span class="ms-2 text-muted">[#{{node.id}}]</span>
                }
                @if (!node.isMeter()) {
                  <button class="tree-button" color="primary" mat-icon-button (click)="onNewMeterBtnClick(node)" matTooltip="Add"><mat-icon>add</mat-icon></button>
                }
                @if (node.isDevice()) {
                  <button class="tree-button" color="primary" mat-icon-button (click)="openDialog(node, true)" matTooltip="Edit"><mat-icon>edit</mat-icon></button>
                }
                @if (node.isDevice()) {
                  <button class="tree-button" color="primary" mat-icon-button [routerLink]="['/device', node.deviceid]" matTooltip="Settings"><mat-icon>settings</mat-icon></button>
                }
              </div>
            </li>
          </mat-nested-tree-node>
          <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChildren">
            <li class="example-tree-container">
              <div class="mat-tree-node">
                <button mat-icon-button matTreeNodeToggle>
                  <mat-icon>
                    {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                  </mat-icon>
                </button>
                <mat-icon>{{node.icon}}</mat-icon>
                <span>{{node.target ? node.target : node.name}}</span>
                <button class="tree-button" color="primary" mat-icon-button (click)="onNewMeterBtnClick(node)" matTooltip="Hozzáadás"><mat-icon>add</mat-icon></button>
                @if (node.isDatalogger()) {
                  <button class="tree-button" color="primary" mat-icon-button (click)="openDialog(node, true)" matTooltip="Edit"><mat-icon>edit</mat-icon></button>
                }
                @if (node.isDatalogger()) {
                  <button class="tree-button" color="primary" mat-icon-button [routerLink]="['/device', node.deviceid]" matTooltip="Settings"><mat-icon>settings</mat-icon></button>
                }
              </div>
              <ul class="example-tree-nested-node">
                @if (treeControl.isExpanded(node)) {
                  <div >
                    <ng-container matTreeNodeOutlet></ng-container>
                  </div>
                }
              </ul>
            </li>
          </mat-nested-tree-node>
        </mat-tree>
      }
    </div>

  </div>
  <div class="col-md-4">
    <div class="device-count pt-3">
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td>Datalogger</td>
            <td class="fw-bold">{{counts.datalogger}}</td>
          </tr>
          <tr>
            <td>Meter</td>
            <td class="fw-bold">{{counts.meter}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
